<template>
  <div id="bx_basket">
    <notifications :group="groupNotify"
                   :closeOnClick="false"
                   :width="600"
                   :max="5"
                   animation-name="v-fade-left"
                   position="top left">
    <template v-slot:body="props">
      <div class="custom-template">
        <div class="custom-template-icon">
          <a target="_blank" :href="props.item.data.url" class="link">
            <img :src="props.item.data.imageSmall">
          </a>
        </div>
        <div class="custom-template-content">
          <div class="custom-template-title">
            {{props.item.title}}
          </div>
          <div class="custom-template-text"
               v-html="props.item.text"></div>
          <div class="custom-template-action">
            <button class="button button_theme_primary_blue button_size_xs" @click="addToCart(props.item.data.id, props.item.data.productId, props.item.data.count)">
                Добавить в корзину
            </button>
          </div>
        </div>
        <div class="custom-template-close"
             @click="close(props.item.data.id, props.item.data.productId)">
          <i class="icon icon-close"></i>
        </div>
      </div>
    </template>
    </notifications>
    <div class="header__profile-mini profile-mini dropdown-label">
      <div class="profile-mini__header">
        <a style="text-decoration: none;" href="/personal/"><span
            class="profile-mini__icon icon icon-profile"></span></a>
      </div>
      <div class="dropdown-label__container">
        <div class="profile-mini__contant">
          <template v-if="user">
            <a href="/personal/" class="profile-mini__link profile-mini__link_profile">{{ user.name }}</a><br>
            <a v-if="user.bonus > 0"  href="/personal/bonus_history/" class="profile-mini__link profile-mini__link_profile">Бонусов: {{ user.bonus }}</a><br v-if="user.bonus > 0" />
            <a href="?logout=yes" class="profile-mini__link profile-mini__link_logout">Выйти</a>
          </template>
          <template v-else>
            <a :href="'/auth/?register=yes&backurl=' + curPage">Регистрация</a><br>
            <a :href="'/auth/?backurl=' + curPage">Вход</a>
          </template>
        </div>
      </div>
    </div>

    <a href="/personal/favorites/" class="favorite-mini dropdown-label">
      <span class="favorite-mini__icon icon icon-heart-full"></span>
    </a>

    <div  class="header__cart-mini cart-mini dropdown-label dropdown-label_cart">
      <span class="cart-mini__header">
        <a href="/personal/cart/" class="cart-mini__icon icon icon-basket-new"></a>
        <span class="cart-mini__count basket_amount">{{ allBasketList.count }}</span>
        <span class="cart-mini__summ-amount basket_price">{{ allBasketList.price | formatMoney}}</span>
      </span>

      <span class="dropdown-label__container" v-if="'volume' in basket && allBasketList.count >= 0 && user">
          <SelectCart></SelectCart>
          <a href="/personal/cart/" class="cart-mini__contant" style="text-decoration: none;">
              <span class="cart-mini__box">
                  Сумма: <span class="cart-mini__value basket_price">{{ allBasketList.price | formatMoney }}</span>
              </span>
              <span class="cart-mini__box">
                  Объем: <span class="cart-mini__value basket_volume">{{ allBasketList.volume | formatVolume }}</span>
              </span>
          </a>
      </span>
    </div>

  </div>
</template>

<script>
import axios from "axios";

import SelectCart from "./SelectCart.vue";

export default {
    name: "MiniBasket",
    data: function () {
      return {
        basket: this.$ls.get('basket')
                ??
                {
                  count: 0,
                  price: 0,
                },
        user: this.$ls.get('user') ?? null,
        waitingList: this.$ls.get('waiting') ?? null,
        curPage: window.btoa(this.$route.path),
        notifyIds: [],
        groupNotify: 'custom-template'
      }
    },
  mounted() {
    this.$ls.on('basket', this.changeBasket);
    document.addEventListener("updateBasket", this.changeBasket);

    this.$ls.on('user', this.changeProfile);
    document.addEventListener("updateProfile", this.changeProfile);

    this.$ls.on('waiting', this.changeWaitingList);
    document.addEventListener("updateWaitingList", this.changeWaitingList);


    this.drawNotify();
  },
  filters: {
    formatMoney: function (value) {
      return parseFloat(value).toFixed(2) + ' Р.';
    },
    formatVolume: function (value) {
      return parseFloat(value).toFixed(4) + ' м³';
    },
    formatWeight: function (value) {
      return (parseFloat(value)/1000).toFixed(2) + ' кг';
    }
  },
  methods: {
    drawNotify: function () {
      if (this.user) {
        if (this.notifyIds.length > 0){
          this.notifyIds.forEach(id => {
            this.$notify.close(id);
          })
        }

        if (this.waitingList) {
          this.waitingList.forEach(waitingItem => {
            const id = waitingItem.id;
            this.notifyIds.push(id);
            this.$notify({
              id,
              group: this.groupNotify,
              title: `Товар поступил на склад`,
              text: waitingItem.name,
              type: '',
              duration: -1,
              speed: 0,
              data: waitingItem
            })
          })
        }
      }
    },
    close: function (id, productId) {
      let vm = this;
      axios.post(
          '/api/transit/hide',
          {
            'productId': productId,
          },
          {
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            }
          }
      ).then(function (response) {
        if (response.status == 200) {
          let data = response.data;
          if (data.status && data.result) {
            vm.removeWaitingList(id);
          } else {
            console.log('Ошибка скрытии товара');
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    removeWaitingList: function (id) {
      this.$notify.close(id);

      let waitingList = this.waitingList;
      waitingList.forEach(function (item, index) {
        if (item.id == id)
          waitingList.splice(index, 1);
      });

      this.$ls.set('waiting', waitingList);
      document.dispatchEvent(new CustomEvent("updateWaitingList", {detail: waitingList}));
    },
    changeBasket: function (event) {
      if (event && 'detail' in event)
        this.basket = event.detail;
      else
        this.basket = event;
    },
    changeProfile: function(event) {
      if (event && 'detail' in event)
        this.user = event.detail;
      else
        this.user = event;
    },
    changeWaitingList: function(event) {
      if (event && 'detail' in event)
        this.waitingList = event.detail;
      else
        this.waitingList = event;

      this.drawNotify();
    },
    addToCart: function (id, productId, count) {
      let vm = this;
      axios.post(
          '/api/transit/cart',
          {
            'id': id,
            'productId': productId,
            'quantity': count
          },
          {
            headers: {
              'content-type': 'application/json; charset=utf8',
              'X-Requested-With': 'XMLHttpRequest',
            }
          }
      ).then(function (response) {
        if (response.status == 200) {
          let data = response.data;
          let basket = vm.basket;
          if (data.status) {
            let result = data.result;
            switch (data.type) {
              case 'add':
                let product = result.product;
                basket.count += product.quantity;
                basket.volume += product.dimensions.volume;
                basket.weight += product.dimensions.weight;
                basket.price = result.price;

                basket.items.push(product)
                vm.removeWaitingList(id);
                break;
              case 'change':
                basket.items.forEach(function (item, index) {
                  if (item.id == result.id) {
                    basket.count += result.quantity;
                    basket.volume += item.dimensions.volume;
                    basket.weight += item.dimensions.weight;

                    item.quantity += result.quantity;
                  }
                })
                basket.price = result.price;
                vm.removeWaitingList(id);
                break;
              default:
                console.log('Ошибка при добавлении товара! Тип');
            }
          } else {
            console.log('Ошибка при добавлении товара! Статус');
          }

          vm.$ls.set('basket', basket);
          document.dispatchEvent(new CustomEvent("updateBasket", {detail: basket}));

          if (!TEST_MODE)
            ym(YANDEX_COUNTER_ID, 'reachGoal', 'ADD_TO_BASKET');
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },

  },
  computed: {
    allBasketList:function(){
      let basket = this.basket.items;
      let price = 0;
      let count = 0;
      let volume = 0;
      basket.forEach(function (item) {
        price += item.price.price * item.quantity;
        count += item.quantity;
        volume += item.dimensions.volume * item.quantity / item.packing.torg.value;
      });
      return {items:basket,price:price,count:count,volume:volume};
    },
  },
  components: {
    SelectCart
  }
}
</script>

<style scoped>

</style>